export default __webpack_public_path__ + "static/media/wristwraps_of_the_forsaken.5dcb99c6.jpg";